import { render } from "./booting.md?vue&type=template&id=6ad68549"
import script from "./booting.md?vue&type=script&lang=js"
export * from "./booting.md?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__